/**
 * FormField component for rendering form fields with Formik.
 * This includes the label, input and error message.
 *
 * ## Example usage:
 *
 *   <FormField component={FormInput} name="firstName" label="Ime" placeholder="Npr. Ivan" />
 */
import React from 'react'
import { ErrorMessage, Field, getIn } from 'formik'
import { Tooltip } from '../Tooltip'

type FormFieldProps = {
    component: React.ComponentType<any>
    autoFocus?: boolean
    name: string
    label?: string
    placeholder?: string
    required?: boolean
    // text, email, password, ...
    type?: string
    tooltip?: string
    // e.g. "numeric" for OIB field or other number only fields
    inputMode?: React.HTMLAttributes<HTMLElement>['inputMode']
}

export function FormField({ component, label, name, tooltip, required = false, autoFocus = false, ...props }: FormFieldProps) {
    return (
        <div className="flex flex-col gap-1.5">
            {label ? (
                <div>
                    <label htmlFor={name}>
                        <span className="text-grey100 font-sm-bold">{label}</span>
                        {required ? <span className="text-red20 ml-1">*</span> : null}
                    </label>
                    {tooltip ? <Tooltip className="ml-1">{tooltip}</Tooltip> : null}
                </div>
            ) : null}

            <Field component={component} name={name} autoFocus={autoFocus} {...props} />

            <ErrorMessage name={name} component="span" className="text-sm text-red20" />
        </div>
    )
}
